<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" class="bgImg" />
      <div>参展指南</div>
    </div>
    <!-- <div class="pdf-box">
      <img src="../../../static/images/index/pdf_bg.png" />
      <div>参展指南PDF</div>
    </div>
    <router-link :to="{path:'/pdfBox',query:{type:2}}" class="pdf-btn">点击查看</router-link> -->
    <div class="noActivity">
      <span class="iconfont icon-kulian"></span>
      <div>2026年资料未更新</div>
    </div>
    <!-- <router-link class="register" to="/expoCard">
      <span class="iconfont icon-zhanshang"></span>参展证申领通道
    </router-link> -->
  </div>
</template>
<script>
export default {
  name: "expoJoinGuide",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped >
.top-box {
  width: 375px;
  height: 103px;
  position: relative;
  div {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}

.bgImg {
  width: 100%;
  height: 100%;
}

.pdf-box {
  margin: 55px auto;
  width: 230px;
  height: 265px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #000000;
  font-size: 25px;
  font-weight: bold;
  img {
    width: 115px;
    height: 115px;
    margin-bottom: 30px;
  }
}

.pdf-btn{
  display: block;
  margin: 22px auto 0;
  width: 230px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background: #EB4D4E;
  border-radius: 22px;
  color: #ffffff;
  font-size: 18px;
}

.noActivity{
  text-align: center;
  font-size: 13px;
  color: #999;
  margin-top: 96px;
}

.noActivity .iconfont{
  font-size: 87px;
  line-height: 87px;
  color: #EEEEEE;
}

.noActivity div{
  margin-top: 25px;
  white-space: pre-line;
}
</style>
